var HighlightWithColumnPipe_1;
import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { SharedConstants } from "../../constants/shared.constants";
let HighlightWithColumnPipe = class HighlightWithColumnPipe {
    static { HighlightWithColumnPipe_1 = this; }
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    static checkColumnsEqual(firstColumn, secondColumn) {
        firstColumn = HighlightWithColumnPipe_1.formatColumnValue(firstColumn);
        secondColumn = HighlightWithColumnPipe_1.formatColumnValue(secondColumn);
        return firstColumn === secondColumn;
    }
    static formatColumnValue(value) {
        return value.toString().trim().replace(" ", "");
    }
    transform(value, searchTerm, column, currentColumn) {
        if (!searchTerm) {
            return value;
        }
        if (!value) {
            return value;
        }
        if (!currentColumn && !column) {
            return value;
        }
        if (!HighlightWithColumnPipe_1.checkColumnsEqual(currentColumn, column) && (currentColumn !== SharedConstants.FILTER_BY_DEFAULT)) {
            return value;
        }
        const stringValue = value.toString();
        const re = new RegExp(searchTerm, "gi");
        const match = stringValue.match(re);
        if (!match) {
            return value;
        }
        const replacedValue = stringValue.replace(re, `<mark> ${match[0]} </mark>`);
        return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    }
    static ctorParameters = () => [
        { type: DomSanitizer }
    ];
};
HighlightWithColumnPipe = HighlightWithColumnPipe_1 = __decorate([
    Pipe({
        standalone: false,
        name: "highlightWithColumn"
    })
], HighlightWithColumnPipe);
export { HighlightWithColumnPipe };
